import {Service} from "angular-ecmascript/module-helpers";

export var Name = '$loadingIndicator';

export default class LoadingIndicator extends Service {
    static $name = Name;
    static $inject = [];

    enabled = true;
    showErrorMessage = true;

    constructor() {
        super(...arguments);
    }

    enable(){
        this.enabled = true;
        this.showErrorMessage = true;
    }

    disable(){
        this.enabled = false;
        this.showErrorMessage = false;
    }
}



// WEBPACK FOOTER //
// ./src/modules/core/components/loading-indicator/loading-indicator.service.js